import { AutoComplete } from "./Suggestions";
import { Box } from "@vinomofo/components";
import Description from "./Description";
import { InstantSearch } from "react-instantsearch-core";
import SearchBox from "./SearchBox";
import algoliasearch from "algoliasearch";
import { useSearch } from "../../hooks/use-search";

const DEFAULT_TITLE = "All Wines";
const DEFAULT_PLACEHOLDER = "Search for wine…";
const DEFAULT_FLAVOUR_TITLE = "The best f@%*ng wine deals on the planet.";
const DEFAULT_FLAVOUR_TEXT =
  "No bowties, no BS. Good wines, the most epic deals and happiness, guaranteed.";

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

interface SearchHeaderProps {
  __typename?: string;
  title?: string;
  placeholder?: string;
  flavourTitle?: string;
  flavourText?: string;
}

export const SearchHeader = ({
  title,
  placeholder,
  flavourTitle,
  flavourText,
}: SearchHeaderProps): JSX.Element => {
  const { query, showSuggestions } = useSearch();

  return (
    <Box display="flex" alignItems="flex-end">
      <Box flexBasis={["100%", "100%", "660px"]} position="relative">
        <SearchBox
          placeholder={placeholder || DEFAULT_PLACEHOLDER}
          title={title || DEFAULT_TITLE}
        />

        {showSuggestions && (
          <InstantSearch
            indexName={
              process.env.GATSBY_ALGOLIA_OFFERS_QUERY_SUGGESTIONS_INDEX
            }
            searchClient={searchClient}
          >
            <AutoComplete defaultRefinement={query} />
          </InstantSearch>
        )}
      </Box>
      <Box
        marginLeft="40px"
        display={["none", "none", "block"]}
        flexBasis="460px"
      >
        <Description
          heading={flavourTitle || DEFAULT_FLAVOUR_TITLE}
          body={flavourText || DEFAULT_FLAVOUR_TEXT}
        />
      </Box>
    </Box>
  );
};
